module.exports = __webpack_public_path__ + "img/brand-07.c1029b45.png";